import React from "react";
import { styled } from "@mui/system";
import Box from "../Box";

type Props = {
  children?: React.ReactNode;
};

export const UIShellNav = styled(
  (props: Props) => <Box>{props.children}</Box>,
  {
    name: "UIShellNav",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));
